var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-wrap"},[_c('div',{staticClass:"view-content"},[_c('onboard-wrap',[_c('h1',[_vm._v("Sorry! It looks like this invite has expired.")]),_vm._v(" "),_c('p',[_vm._v("Please check with your admin to get a new invite.")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg",attrs:{"href":"/"}},[_vm._v("Go Home")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c9e138c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/invalid/invalid.vue
// module id = null
// module chunks = 